import { render, staticRenderFns } from "./registerModal.vue?vue&type=template&id=a70f4b86&scoped=true"
import script from "./registerModal.vue?vue&type=script&lang=js"
export * from "./registerModal.vue?vue&type=script&lang=js"
import style0 from "./registerModal.vue?vue&type=style&index=0&id=a70f4b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70f4b86",
  null
  
)

export default component.exports